export const lobbies = [
  {
    username: "Pondorasti",
    gameLogo:
      "https://logos-world.net/wp-content/uploads/2020/04/Minecraft-Logo.png",
    description:
      "This is my room decription, this should be no more than three lines long...",
    platform: "PS5",
    usesMic: false,
    sizeStatus: "3/5",
  },
  {
    username: "Pondorasti",
    gameLogo:
      "https://logos-world.net/wp-content/uploads/2020/04/Minecraft-Logo.png",
    description:
      "This is my room decription, this should be no more than three lines long...",
    platform: "PC",
    usesMic: true,
    sizeStatus: "3/10",
  },
  {
    username: "Pondorasti",
    gameLogo:
      "https://logos-world.net/wp-content/uploads/2020/04/Minecraft-Logo.png",
    description:
      "This is my room decription, this should be no more than three lines long...",
    platform: "Xbox One",
    usesMic: false,
    sizeStatus: "3/5",
  },
  {
    username: "Pondorasti",
    gameLogo:
      "https://logos-world.net/wp-content/uploads/2020/04/Minecraft-Logo.png",
    description:
      "This is my room decription, this should be no more than three lines long...",
    platform: "Switch",
    usesMic: true,
    sizeStatus: "1/8",
  },
  {
    username: "Pondorasti",
    gameLogo:
      "https://logos-world.net/wp-content/uploads/2020/04/Minecraft-Logo.png",
    description:
      "This is my room decription, this should be no more than three lines long...",
    platform: "Xbox One",
    usesMic: false,
    sizeStatus: "3/5",
  },
  {
    username: "Pondorasti",
    gameLogo:
      "https://logos-world.net/wp-content/uploads/2020/04/Minecraft-Logo.png",
    description:
      "This is my room decription, this should be no more than three lines long...",
    platform: "Xbox One",
    usesMic: false,
    sizeStatus: "3/5",
  },
  {
    username: "Pondorasti",
    gameLogo:
      "https://logos-world.net/wp-content/uploads/2020/04/Minecraft-Logo.png",
    description:
      "This is my room decription, this should be no more than three lines long...",
    platform: "Xbox One",
    usesMic: false,
    sizeStatus: "3/5",
  },
  {
    username: "Pondorasti",
    gameLogo:
      "https://logos-world.net/wp-content/uploads/2020/04/Minecraft-Logo.png",
    description:
      "This is my room decription, this should be no more than three lines long...",
    platform: "Xbox One",
    usesMic: false,
    sizeStatus: "3/5",
  },
  {
    username: "Pondorasti",
    gameLogo:
      "https://logos-world.net/wp-content/uploads/2020/04/Minecraft-Logo.png",
    description:
      "This is my room decription, this should be no more than three lines long...",
    platform: "Xbox One",
    usesMic: false,
    sizeStatus: "3/5",
  },
  {
    username: "Pondorasti",
    gameLogo:
      "https://logos-world.net/wp-content/uploads/2020/04/Minecraft-Logo.png",
    description:
      "This is my room decription, this should be no more than three lines long...",
    platform: "Xbox One",
    usesMic: false,
    sizeStatus: "3/5",
  },
  {
    username: "Pondorasti",
    gameLogo:
      "https://logos-world.net/wp-content/uploads/2020/04/Minecraft-Logo.png",
    description:
      "This is my room decription, this should be no more than three lines long...",
    platform: "Xbox One",
    usesMic: false,
    sizeStatus: "3/5",
  },
  {
    username: "Pondorasti",
    gameLogo:
      "https://logos-world.net/wp-content/uploads/2020/04/Minecraft-Logo.png",
    description:
      "This is my room decription, this should be no more than three lines long...",
    platform: "Xbox One",
    usesMic: false,
    sizeStatus: "3/5",
  },
  {
    username: "Pondorasti",
    gameLogo:
      "https://logos-world.net/wp-content/uploads/2020/04/Minecraft-Logo.png",
    description:
      "This is my room decription, this should be no more than three lines long...",
    platform: "Xbox One",
    usesMic: false,
    sizeStatus: "3/5",
  },
  {
    username: "Pondorasti",
    gameLogo:
      "https://logos-world.net/wp-content/uploads/2020/04/Minecraft-Logo.png",
    description:
      "This is my room decription, this should be no more than three lines long...",
    platform: "Xbox One",
    usesMic: false,
    sizeStatus: "3/5",
  },
  {
    username: "Pondorasti",
    gameLogo:
      "https://logos-world.net/wp-content/uploads/2020/04/Minecraft-Logo.png",
    description:
      "This is my room decription, this should be no more than three lines long...",
    platform: "Xbox One",
    usesMic: false,
    sizeStatus: "3/5",
  },
  {
    username: "Pondorasti",
    gameLogo:
      "https://logos-world.net/wp-content/uploads/2020/04/Minecraft-Logo.png",
    description:
      "This is my room decription, this should be no more than three lines long...",
    platform: "Xbox One",
    usesMic: false,
    sizeStatus: "3/5",
  },
  {
    username: "Pondorasti",
    gameLogo:
      "https://logos-world.net/wp-content/uploads/2020/04/Minecraft-Logo.png",
    description:
      "This is my room decription, this should be no more than three lines long...",
    platform: "Xbox One",
    usesMic: false,
    sizeStatus: "3/5",
  },
]

export default lobbies
